import customConfig from 'src/config';

import { DlpTemplateDetail, PolicyHolderTypeEnum } from '../utils/types';
import { TFunction } from 'i18next';
import { Region } from '../../../types';
import { setNestObjByKeyArr } from '../utils/fns';
import {
  getTargetProperty,
  policyNotificationProductNameReplace,
} from './cfg.default';
import cloneDeep from 'lodash/cloneDeep';

import { isInUIC } from '@Utils/common';
import { IS_UAE } from '@Utils/const';
// const envSettings = window as any;
const config = {
  policyRmsEnabled: 0,
  policyRealtimeEnabled: 0,
  policyDescription: '',
  policyName: '',
  policyTarget: {
    targetType: 'user',
    targetGroups: [],
    targets: [],
    empty: true,
  },
  policyHolderType: PolicyHolderTypeEnum.DLP, //1: ATP, 2: DLP
  policyType: 1,
  isSkipFolderEnabled: 0,
  policyPriority: 1,
  tmDpfilters: {
    dpEnabled: 0,
    dpReplacementText:
      'This file is %Action% because it triggered %FilterName%.\nContact your Cloud App Security administrator for further support or information.',
    dpApplyBound: 7,
    dpSentItemEnabled: 0,
    dpSentItemAction: 6,
    dpViolationContentEnabled: 1,
    dpViolationContentMode: 0,
    dpFileAction: 251,
    dpMipOverrideEnabled: 0,
    dpMipBackupEnabled: 0,
    dpMipBackupAction: 6,
    dpSubjectScanEnabled: 1,
    dpBodyScanEnabled: 1,
    dpAttachmentScanEnabled: 1,
    dpMailHeadersScanEnabled: 0,
    dpMailHeaders: '',
    dpSecondActionEnabled: 0,
    dpSecondActionType: 6,
    notification: {
      ntfRecipientGroupEnabled: 1,
      ntfRecipientGroupId: 1,
      ntfAdminIntervalNum: 2,
      ntfAdminIntervalType: 0,
      ntfAdminNotifySettingType: 0,
      ntfAdminOccurenceNum: 50,
      ntfEnableNotifyAdmin: 1,
      ntfEnableNotifyRecipient: 0,
      ntfEnableEndUserRestore: 0,
      ntfDoNotNotifyExternalUser: 0,
      ntfToAccount: '',
      ntfAdminMessage:
        'Cloud App Security detected an email message that triggered Data Loss Prevention policy violation.\r\n\r\nAction taken: %action%\r\nMessage details:\r\n\tReceived: %date% %time%\r\n\tFound in: %foundin%\r\n\tTriggered policy: %policy_name%\r\n\tSender: %sender%\r\n\tRecipient: %recipient%\r\n\tSubject: %subject%\r\n\tDLP template name: %dlptemplatename%',
      ntfAdminSubject: 'Trend Micro Cloud App Security Data Loss Prevention',
      ntfInternalRecipientMessage:
        'Cloud App Security detected an email message that triggered Data Loss Prevention policy violation, and took action on it to comply with the information security policies of the organization.\r\n\r\nAction taken: %action%\r\nMessage details:\r\n\tReceived: %date% %time%\r\n\tFound in: %foundin%\r\n\tTriggered policy: %policy_name%\r\n\tSender: %sender%\r\n\tRecipient: %recipient%\r\n\tSubject: %subject%\r\n\tDLP template name: %dlptemplatename%\r\n\r\n',
      ntfInternalRecipientSubject:
        'Trend Micro Cloud App Security Data Loss Prevention',
    },
    dpFileTagContent: '[ProbableLeakage]',
    changeRecipientDisclaimer:
      'This email is redirected to you because it violates your organization’s Data Loss Prevention policy (%policy_name%). Contact your Cloud App Security administrator for further support or information.',
    dpMipLabelId: '',
    dpMipLabelName: '',
    changeRecipientEmailAddressList: '',
    tmDpfilterrules: [],
    tmMipLabelRules: [],
    dpApprovedSenderEmailEnabled: 0,
    dpApprovedSenderEmailEntries: '',
  },
};

export function getDefaultDlpConfig() {
  return cloneDeep(config);
}

export const dlpTemplateDetail: DlpTemplateDetail = {
  dpTemplateDesc: '',
  dpTemplateName: '',
  template: { matchRule: [] },
};

/**
 * do not remove this function
 * Allen Shao
 */
const i8nReplaceKeys: string[] = [
  'policy.policyTemplate.tmDpfilters.dpReplacementText',
  'policy.policyTemplate.tmDpfilters.notification.ntfToAccount',
  // 'policy.policyTemplate.tmKeywordfilters.notification.ntfToAccount',
  // 'policy.policyTemplate.tmKeywordfilters.kfReplacementText',
  // 'policy.policyTemplate.tmSlfFilters.notification.ntfToAccount',
  'policy.policyTemplate.tmDpfilters.dpFileTagContent',
  'policy.policyTemplate.tmDpfilters.changeRecipientDisclaimer',
  // 'policy.policyTemplate.SF.tmDpfilters.notification.ntfAdminMessage',
  // 'policy.policyTemplate.SF.tmDpfilters.notification.ntfAdminSubject',
  // 'policy.policyTemplate.SF.tmDpfilters.notification.ntfInternalRecipientMessage',
  // 'policy.policyTemplate.SF.tmDpfilters.notification.ntfInternalRecipientSubject',
  // 'policy.policyTemplate.BOX.tmKeywordfilters.notification.ntfAdminMessage',
  // 'policy.policyTemplate.BOX.tmKeywordfilters.notification.ntfAdminSubject',
  // 'policy.policyTemplate.BOX.tmKeywordfilters.notification.ntfInternalRecipientMessage',
  // 'policy.policyTemplate.BOX.tmKeywordfilters.notification.ntfInternalRecipientSubject',
  // 'policy.policyTemplate.BOX.tmSlfFilters.notification.ntfAdminMessage',
  // 'policy.policyTemplate.BOX.tmSlfFilters.notification.ntfAdminSubject',
  // 'policy.policyTemplate.BOX.tmSlfFilters.notification.ntfInternalRecipientMessage',
  // 'policy.policyTemplate.BOX.tmSlfFilters.notification.ntfInternalRecipientSubject',
  // 'policy.policyTemplate.MIP_SP.tmDpfilters.notification.ntfAdminMessage',
  // 'policy.policyTemplate.MIP_OD.tmDpfilters.notification.ntfAdminMessage',
  // 'policy.policyTemplate.MIP_MT.tmDpfilters.notification.ntfAdminMessage',
  // 'policy.policyTemplate.MIP_SP.tmDpfilters.notification.ntfInternalRecipientMessage',
  // 'policy.policyTemplate.MIP_OD.tmDpfilters.notification.ntfInternalRecipientMessage',
  // 'policy.policyTemplate.MIP_MT.tmDpfilters.notification.ntfInternalRecipientMessage',
];
console.log('i8nReplaceKeys', i8nReplaceKeys);

function dlpWhiteLabelingStringReplace(config: any) {
  ['tmDpfilters', 'tmKeywordfilters', 'tmSlfFilters'].forEach((key) => {
    if (config[key] && config[key].notification) {
      for (const item in config[key].notification) {
        if (typeof config[key].notification[item] === 'string') {
          config[key].notification[item] = config[key].notification[item]
            .replace(
              /Trend Micro/g,
              customConfig.ui.feature.whiteLabeling.firstName
            )
            .replace(
              /Cloud App Security/g,
              customConfig.ui.feature.whiteLabeling.lastName
            );
        }
      }
    }
  });
}

function defaultAccountReplace(config: any, accountEmail: string) {
  ['tmDpfilters', 'tmKeywordfilters', 'tmSlfFilters'].forEach((key) => {
    if (config[key] && config[key].notification) {
      // console.log('config[key].notification.ntfToAccount', key, accountEmail);
      config[key].notification.ntfToAccount = accountEmail;
    }
  });
}

export function getDlpTemplateConfig(
  t: TFunction<'translation'>,
  config: any,
  accountEmail: string | undefined,
  coverI18nKeys: string[],
  ntfI18nKeys: string[]
) {
  console.log(config);
  try {
    i8nReplaceKeys.concat(coverI18nKeys).forEach((key) => {
      const targetProperty = getTargetProperty(key, 2);
      if (targetProperty !== null) {
        const propArr: string[] = targetProperty?.split('.');
        setNestObjByKeyArr(config, propArr, t(key));
      }
    });

    //ntf key always have service name,for example :"policy.policyTemplate.EX.tmDdafilters.notification.ntfAdminSubject",
    ntfI18nKeys.forEach((key) => {
      const targetProperty = getTargetProperty(key, 3);
      if (targetProperty !== null) {
        const propArr: string[] = targetProperty?.split('.');
        setNestObjByKeyArr(config, propArr, t(key));
      }
    });
    if (
      customConfig.ui.feature.whiteLabeling.enabled &&
      window.DEPLOY_REGION === Region.UAE
    ) {
      dlpWhiteLabelingStringReplace(config);
    }

    if (isInUIC()) {
      config = policyNotificationProductNameReplace(
        config,
        'Cloud App Security',
        'Cloud Email and Collaboration Protection'
      );
    } else if (IS_UAE) {
      config = policyNotificationProductNameReplace(
        config,
        'Trend Micro',
        'Cyber Eye'
      );
      config = policyNotificationProductNameReplace(
        config,
        'Cloud App Security',
        'Cloud Service Security'
      );
    }
    // replace default account
    if (accountEmail) {
      defaultAccountReplace(config, accountEmail);
    }
  } catch (e) {
    console.log(e);
  }

  return config;
}
